
import { SearchContext, SearchKey } from "@/composables/useSearch";
import { computed, defineComponent, inject } from "vue";

export default defineComponent({
  setup() {
    const { title, category, author, showResult } = inject(
      SearchKey
    ) as SearchContext;

    const params = computed(
      () =>
        `title:${title.value}, author:${
          author.value
        }, category:${category.value.join(",")}`
    );
    return { params, showResult };
  },
});
